import { NodeViewProps, NodeViewWrapper } from '@tiptap/react'
import { useCallback, useRef } from 'react'

const ImageViewBlock = ({ editor, node, updateAttributes, getPos }: NodeViewProps) => {
    const imgRef = useRef<HTMLImageElement>(null)

    const isSelected = editor.state.selection.from === getPos()

    const handleMouseDown = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault()
            const startX = e.clientX
            const startWidth = imgRef.current?.offsetWidth ?? 300

            const onMouseMove = (e: MouseEvent) => {
                const newWidth = Math.max(50, startWidth + (e.clientX - startX))
                updateAttributes({ width: newWidth })
            }

            const onMouseUp = () => {
                window.removeEventListener('mousemove', onMouseMove)
                window.removeEventListener('mouseup', onMouseUp)
            }

            window.addEventListener('mousemove', onMouseMove)
            window.addEventListener('mouseup', onMouseUp)
        },
        [updateAttributes],
    )

    return (
        <NodeViewWrapper as="span" style={{ display: 'inline-block' }}>
            <span
                draggable
                data-drag-handle
                style={{
                    display: 'inline-block',
                    position: 'relative',
                    width: node.attrs.width ? `${node.attrs.width}px` : 'auto',
                    maxWidth: '100%',
                    lineHeight: 0,
                    boxShadow: isSelected ? '0 0 0 2px hsl(var(--primary))' : 'none',
                    borderRadius: '4px',
                }}
            >
                <img
                    ref={imgRef}
                    src={node.attrs.src}
                    alt={node.attrs.alt}
                    style={{ width: '100%', display: 'block', borderRadius: '4px' }}
                />
                {editor.isEditable && (
                    <span
                        onMouseDown={handleMouseDown}
                        style={{
                            position: 'absolute',
                            right: -4,
                            top: 0,
                            width: 8,
                            height: '100%',
                            cursor: 'ew-resize',
                            background: isSelected ? 'hsl(var(--primary) / 0.3)' : 'transparent',
                            borderRadius: '0 4px 4px 0',
                        }}
                    />
                )}
            </span>
        </NodeViewWrapper>
    )
}

export { ImageViewBlock }
